import { useQuery } from "@tanstack/react-query";

import API from "@/api";

function useNursery(nurseryId: string, enabled: boolean = true) {
  const { isPending, error, data } = useQuery({
    queryKey: ["nurseries", nurseryId],
    queryFn: () => API.getNursery(nurseryId),
    enabled: enabled
  });

  return {
    isPending,
    error,
    data
  };
}

export default useNursery;
